import { ActionElement, Field, QueryBuilder, RuleGroupTypeIC } from 'react-querybuilder';
import { QueryBuilderDnD } from '@react-querybuilder/dnd';
import RemoveAction from '../QueryBuilder/RemoveAction';
import React, { useState } from 'react';
import * as ReactDnD from 'react-dnd';
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend';
import DropdownAutocomplete from '@/components/FormFields/DropdownAutocomplete';

interface UserAttribute {
  id: number;
  name: string;
  valueStringTypeHint: string | null;
  userAttributesValueString: { id: number; valueString: string }[] | null;
}

function transformArray(objects: UserAttribute[]): Field[] {
  return objects?.map((obj) => {
    let values;
    if (obj.userAttributesValueString && obj.userAttributesValueString.length > 0) {
      values = obj.userAttributesValueString.map((attr) => ({
        name: attr.valueString,
        label: attr.valueString,
      }));
    } else {
      values = [
        { name: 'true', label: 'true' },
        { name: 'false', label: 'false' },
        { name: 'not_set', label: 'not_set' },
      ];
    }

    return {
      name: obj.name || 'unknown_name',
      label: obj.name || 'unknown_name',
      valueEditorType: 'select',
      values: values,
    };
  });
}

const CustomInputEditor = (props: any) => {
  const data = props.options
    ? ['Select...', ...props.options.map((v: { name: any }) => v.name)]
    : ['Select...', ...props.values.map((v: { name: any }) => v.name)];

  const initialValue = !props.value || props.value === '' ? 'Select...' : props.value;

  return (
    <DropdownAutocomplete
      value={initialValue}
      options={data}
      onChange={(value) => {
        if (value !== 'Select...') {
          props.handleOnChange(value);
        } else {
          props.handleOnChange(null);
        }
      }}
      onBlur={props.onBlur}
      sx={{ width: '100%' }}
    />
  );
};

const CustomCombinatorSelector = (props: any) => {
  const options = [
    { name: 'AND', label: 'AND' },
    { name: 'OR', label: 'OR' },
  ];

  return (
    <DropdownAutocomplete
      value={props.value.toUpperCase()}
      options={options.map((option) => option.label)}
      onChange={(value) => props.handleOnChange(value)}
      onBlur={props.onBlur}
      sx={{ width: '100px', flexShrink: 0 }}
    />
  );
};

export const UserAttribute = (props: any) => {
  const defaultQuery: RuleGroupTypeIC = {
    rules: [
      {
        field: '',
        operator: '=',
        value: null,
      },
    ],
  };

  const [query, setQuery] = useState<RuleGroupTypeIC>(props?.input?.value || defaultQuery);
  const { onChange } = props.input;

  const handleQueryChange = (newQuery: RuleGroupTypeIC) => {
    setQuery(newQuery);
    onChange(newQuery);
  };

  return (
    <div className='queryBuilder'>
      <QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
        <QueryBuilder
          fields={transformArray(props.userAttributes)}
          query={query}
          onQueryChange={handleQueryChange}
          independentCombinators={true}
          controlElements={{
            valueEditor: CustomInputEditor,
            fieldSelector: CustomInputEditor,
            combinatorSelector: CustomCombinatorSelector,
            addGroupAction: (aeProps) => (aeProps.level === 0 ? <ActionElement {...aeProps} /> : null),
            removeRuleAction: RemoveAction,
            removeGroupAction: RemoveAction,
          }}
          addRuleToNewGroups
          getDefaultField={() => ''}
          getDefaultOperator={() => '='}
          getDefaultValue={() => null}
        />
      </QueryBuilderDnD>
    </div>
  );
};
